var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ShowSchool"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Home",
    d: "M9.40035 12.396V8.06789C9.40035 7.79533 9.19356 7.57482 8.9372 7.57482H7.10157C6.8452 7.57482 6.637 7.79533 6.637 8.06926V12.5316C6.637 12.7891 6.83387 12.9986 7.07607 12.9986H12.175C12.4611 12.9986 12.6934 12.7521 12.6934 12.448V7.88299C12.6934 7.71315 12.8223 7.57482 12.9824 7.57482H13.6693C13.9965 7.57482 14.124 7.12284 13.852 6.93108L8.37773 3.08237C8.22334 2.97417 8.02505 2.9728 7.86925 3.07689L2.15557 6.92287C1.87371 7.11188 1.99977 7.57619 2.33403 7.57619H3.04789C3.23202 7.57619 3.38074 7.73507 3.38074 7.93093V12.5699C3.38074 12.8069 3.56203 13 3.78441 13H5.72626",
    stroke: "#026094",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 457",
    d: "M7 7L9 9L14 4",
    stroke: "#3AC47D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowSchool);
export default __webpack_public_path__ + "static/media/ShowSchool.37f77be86fb57d014da7ab922f8c426f.svg";
export { ForwardRef as ReactComponent };